/**
 * @description 系統參數 是/否 用
*/
export enum YesNo {
  /** 是 */
  Yes = 'Y',
  /** 否 */
  No = 'N'
}

/**
 * @description 是/否 用
*/
export enum YesNoType {
  /** 是 */
  Yes = '1',
  /** 否 */
  No = '0',
  /** 無關 */
  Other = '2'
}
